import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import TitlePill from '../TitlePill';
import Breadcrumb from '../Breadcrumb';

function ChallengeBanner({
    image,
    title,
    badge,
    navigation,
    status,
    iconClass,
    creator,
    isChallengeBanner,
    id,
    isChallenge,
}) {
    return (
        <div>
            <div
                className="innerBanner"
                style={{ backgroundImage: `url('${image}')` }}
            >
                <div className="after"></div>
                <div className="content">
                    <div className="bannerBadge">
                        <TitlePill badgeTitle={badge} />
                        {status && (
                            <TitlePill
                                badgeStyle={'simple badge-custom'}
                                badgeTitle={status}
                            />
                        )}
                    </div>
                    <h1 className="challenge-details-text">
                        {title}
                        <br />
                        {title && isChallenge && (
                            <span
                                style={{
                                    textTransform: 'uppercase',
                                    fontFamily: 'Proxima Nova Bld',
                                    letterSpacing: 0.5,
                                    fontSize: 16,
                                    position: 'absolute',
                                }}
                            >
                                Challenge ID: {id}
                            </span>
                        )}
                        {creator && (
                            <span
                                style={{
                                    textTransform: 'uppercase',
                                    fontFamily: 'Proxima Nova Bld',
                                    letterSpacing: 0.5,
                                    fontSize: 16,
                                }}
                            >
                                Created By {creator}
                            </span>
                        )}
                    </h1>
                </div>
            </div>

            <Breadcrumb
                navigation={navigation}
                isChallengeBanner={isChallengeBanner}
                iconClass={iconClass}
                id={id}
            />
        </div>
    );
}

ChallengeBanner.propTypes = {
    // banner image to be displayed
    image: PropTypes.string,
    // banner title to be displayed
    title: PropTypes.string,
    isChallenge: PropTypes.bool,

    status: PropTypes.string,
    // banner text to be displayed inside badge
    badge: PropTypes.string,
    // navigation stack to display inside breadcrumb
    navigation: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            path: PropTypes.string,
        }),
    ),
    // icon to display in breadcrumb
    iconClass: PropTypes.string,
    creator: PropTypes.string,
    id: PropTypes.string,
    isChallengeBanner: PropTypes.bool,
};

ChallengeBanner.defaultProps = {
    image: null,
    title: null,
    status: '',
    isChallenge: false,
    badge: null,
    navigation: [],
    iconClass: '',
    creator: '',
    id: '',
    isChallengeBanner: false,
};

export default ChallengeBanner;
